export const ProductSku = {
	DebitCard: "ORG-CARD-DEBIT_01-SVEA",
	CreditCard: "ORG-CREDITCARD-CREDITCARD_01-SVEA",
	ForetagarnaDebitCard: "ORG-CARD-FORETAGARNA_DEBIT_01-SVEA",
	ForetagarnaCreditCard: "ORG-CREDITCARD-FORETAGARNA_CREDITCARD_01-SVEA",
	Businessloan: "ORG-CREDIT-BUSINESSLOAN_01-SVEA",
	ForetagarnaMembership: "ORG-PARTNERSHIP-FORETAGARNA_01-SVEA",
	CheckCredit: "ORG-CREDIT-CHECKCREDIT_01-SVEA",
	Sparkonto: "ORG-ACCOUNT-SAVINGS_01-SVEA",
	Utlandsbetalning: "ORG-PAYMENT-INTERNATIONAL_01-SVEA",
	Bankgiro: "ORG-PAYMENT-BG_01-SVEA",
	Transaktionskonto: "ORG-ACCOUNT-TRANSACTION_01-SVEA",
	DatasharingConsent: "ORG-BAAS-CONSENT_01-SVEA",
	PaymentsCheckout: "ORG-PARTNERSHIP-PAYMENTS_CHECKOUT_01-SVEA",
	SwishCBase: "ORG-PAYMENT-SWISHCBASE_01-SVEA",
	SwishCommerce: "ORG-PAYMENT-SWISHCOMMERCE_01-SVEA",
	SwishPayout: "ORG-PAYMENT-SWISHPAYOUT_01-SVEA",
	BankCertificateFee: "ORG-SERVICES-BANKCERTIFICATEFEE_01-SVEA",
} as const;

export type ProductSkuKey = keyof typeof ProductSku;
export type ProductSkuValue = (typeof ProductSku)[ProductSkuKey];
